"use strict";import{useCallback}from"react";export function useWorkletCallback(worklet,deps){return useCallback(worklet,deps??[])}